export default "__VITE_ASSET__BBn2UeEV__"